import { BaseService } from "@/core/services/BaseService";
import { ENDPOINT } from "@/core/config/Constant";
import { ICase } from "@/core/entity/ICase";

class PolicyService extends BaseService<any> {
  endpoint = ENDPOINT.POLICY;

  /**
   * @deprecated
   */
  async getCases(id: string) {
    return await this.http().get<ICase>(this.endpoint + "/" + id + "/cases").then(res => {
      return res.data
    })
  }

  async updateBenefits(id: string, model: any) {
    return this.http().put(this.endpoint + "/" + id + "/policy-benefits", model).then(res => {
      return res.data
    })
  }

  async getCoverageConfirm(id) {
    return await this.http().get(this.endpoint + "/" + id + "/coverage-confirmation",
      {responseType: "blob"}).then(res => {
      return res;
    })
  }
}

export default new PolicyService();